import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import DashboardLayout from '../../components/Layout/DashboardLayout';
import AlertMessage from '../../components/ui/AlertMessage'; // Assuming you have or will create this
import CheckinStep from '../../components/ui/CheckinStep'; // Reusing from user screen, or create a supplier-specific one
import useSupplierProfilesStatus from '../../hooks/useSupplierProfilesStatus';

const HomeSupplierScreen = () => {
    const location = useLocation();
    const {
        supplierProfiles,
        loadingProfiles,
        errorProfiles,
        hasPreEvaluacion,
        hasSelloCheckin
    } = useSupplierProfilesStatus();

    // Placeholder data - this would typically come from an API
    const supplierName = "Juan Méndez"; // Example, fetch dynamically

    const supplierCheckinSteps = [
        { id: 1, text: "Registro completo", status: "completed" },
        { id: 2, text: "Completar Pre-Evaluación", status: hasPreEvaluacion ? "completed" : "pending" },
        { id: 3, text: "Completar formulario Sello Checkin", status: hasSelloCheckin ? "completed" : "pending" },
        // Add more steps as needed
    ];

    const supplierAlert = <>
        <span>
            Recuerda realizar todos los <b><Link to="/training" className='text-checkin'>talleres de capacitación</Link></b> antes de postular al sello CheckIn
        </span>
    </>;

    return (
        <DashboardLayout activeMenuItem="Inicio" userRole="supplier">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3">
                <h1 className="h2 mb-0">¡Bienvenido/a!</h1> {/* Adjusted mb-4 to mb-0 */}
                <div className="btn-toolbar mb-2 mb-md-0">
                    {!loadingProfiles && !errorProfiles && (
                        <>
                            {!hasPreEvaluacion && !hasSelloCheckin && (
                                <Link to="/supplier/questions-pe/pestep1_1" className="btn btn-success d-flex align-items-center">
                                    Ingresar al formulario de pre-evaluación
                                </Link>
                            )}
                            {hasPreEvaluacion && !hasSelloCheckin && (
                                <Link to="/supplier/questions/pstep1_1" className="btn btn-success d-flex align-items-center">
                                    Ingresar al formulario de evaluación
                                </Link>
                            )}
                        </>
                    )}
                    {loadingProfiles && <span>Loading...</span>}
                    {errorProfiles && <AlertMessage message={`Error loading profiles: ${errorProfiles}`} />}
                </div>
            </div>

            <AlertMessage
                message={supplierAlert}
            />

            {/* Metrics section can be added here if needed, similar to HomeUserScreen */}
            {/* <div className="row text-center my-4">
                {metrics.map(metric => (
                    <MetricCard key={metric.id} value={metric.value} text={metric.text} />
                ))}
            </div> */}

            <h3 className="mb-3 mt-4">Tu ruta como proveedor</h3> {/* Added mt-4 for spacing after alert */}
            <p className="mb-4 text-muted">Tu información paso a paso</p>

            <div className="list-group gap-3">
                {supplierCheckinSteps.map(step => (
                    <CheckinStep
                        key={step.id}
                        text={step.text}
                        status={step.status}
                    // You might want to pass different icons or styles for supplier steps
                    />
                ))}
            </div>

            {/* Copyright can be part of DashboardLayout's footer or added here if specific to this page */}
            {/* <div className="copyright mt-5">
                <p className="text-center text-muted small">© {new Date().getFullYear()} Checkin. Todos los derechos reservados. Desarrollado por <a href="https://antudigital.cl" target="_blank" rel="noopener noreferrer">Antü Digital</a></p>
            </div> */}
        </DashboardLayout>
    );
};

export default HomeSupplierScreen;